<template>
</template>

<script>
/* eslint-disable camelcase */

import API, { graphqlOperation } from '@aws-amplify/api';
import { Auth, Storage } from 'aws-amplify';
import axios from 'axios';
import * as mutations from '../api/graphql/mutations.ts';
import * as queries from '../api/graphql/queries.ts';

import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import Events from '../assets/javascripts/Events';
import FileTypes from '../assets/javascripts/FileTypes';
import Theme from '../assets/javascripts/Theme';

import ConfirmPopup from '@/components/ConfirmPopup.vue';
import Fillet from '@/components/Fillet.vue';
import GuidelinePopup from '@/components/GuidelinePopup.vue';
import Nesting from '@/components/Nesting.vue';
import QuotationPopup from '@/components/QuotationPopup.vue';
import Timeline from '@/components/Timeline.vue';
import PluginStep1Menu from '@/components/plugin/PluginStep1Menu.vue';
import PluginStep2Menu from '@/components/plugin/PluginStep2Menu.vue';
import PluginStep3Menu from '@/components/plugin/PluginStep3Menu.vue';
import PathController from '../assets/javascripts/controllers/PathController';
import PluginStepper from '../components/plugin/PluginStepper.vue';

import CostItem from '../assets/javascripts/CostItem';
import { formatTime } from '../assets/javascripts/Formatter';
import SBPZip from '../assets/javascripts/sbp/SBPZip';

import CamErrors from '@/assets/jsons/cam_errors.json';
import CamWarnings from '@/assets/jsons/cam_warnings.json';
import NestingErrors from '@/assets/jsons/nesting_errors.json';
import PageBase from './PageBase.vue';
import { cwLogger } from '../cwLogger.js';
import { Cache } from '../assets/javascripts/Cache';

const nestingApiRoot = (process.env.API_ENV === 'development') ?
  'https://nesting-v2-dev.emarf.co' : 'https://nesting-v2.emarf.co';

const queryProjectIdKey = 'project_id';

export default {
  name: 'PluginBase',
  extends: PageBase,

  components: {
    PluginStep1Menu,
    PluginStep2Menu,
    PluginStep3Menu,
    PluginStepper,
    QuotationPopup,
    ConfirmPopup,
    GuidelinePopup,
    Fillet,
    Nesting,
    Timeline
  },

  response: null,
  pathJsonUrl: '',
  pathJson: null,
  axiosCancelTokenSource: axios.CancelToken.source(),

  data () {
    const defaultMillSize = 6.35;
    const userId = this.$emarf.isProd ? 7915 : 13; // VUILD加工拠点アカウントのID

    // キャッシュから値を取得
    const cachedMaterialId = Cache.get('material_id');
    const cachedMaterialAssortmentId = Cache.get('material_assortment_id');
    const cachedFinish = Cache.get('finish');
    const cachedBezel = Cache.get('bezel');
    const cachedPaintData = Cache.get('paint_data');

    return {
      debug: false,
      step: 0,
      error: false,
      isSbp: false,
      isRequestingCAM: false,
      isRequestingNesting: false,
      project: {},
      properties: {
        isCustomSend: false,
        isBeginner: false,
        isExpert: false,
        unloadSettings: ["name","isBeginner", "isExpert","thickness", "bin", "quantity", "unloadSettings",
        "material_id", "material_assortment_id", "bezel", "paint_data", "finish", 
        "hasHolePoints", "hasScrew", "hasSheetSize", "isCustomSend",
        "plugin"], //ロードしない設定
        name: this.$t('タイトルなし'),
        thickness: 24,
        bin: { width: 1820, depth: 910, millSize: 0 },
        quantity: 1,
        material_id: cachedMaterialId || 1,
        material_assortment_id: cachedMaterialAssortmentId || 1,
        bezel: cachedBezel || 0,
        paint_data: cachedPaintData || { id: 0, unitCost: 0, name: '-' },
        finish: cachedFinish || { burr: false, sanding: false },
        millSize: defaultMillSize,
        rotationSpeed: 18000,
        xySpeed: 60,
        zSpeed: 25,
        jogSpeed: 100,
        pathHeight: defaultMillSize,
        vBitPathHeight: 3,
        pocketStep: defaultMillSize * 0.4,
        pocketPathHeight: defaultMillSize,
        tabWidth: 10,
        tabHeight: 8,
        isTriangularTab: false,
        isTrimmerHole: false,
        trimmerHoleOffset: 0.5,
        isFirstCutCW: false,
        firstCutOffset: false,
        firstCutInPathOffset: false,
        firstCutOffsetValue: 0.2,
        firstCutPathHeightList: [defaultMillSize],
        secondCutPathHeightList: [25.4],
        addSecondCut: false,
        isSecondCutCW: false,
        secondPathHeight: 25.4,
        changeSecondCutSpeed: false,
        secondCutXYSpeed: 42,
        secondCutZSpeed: 25,
        holeDiameter: 14,
        holePathHeight: 6,
        holeRotation: 6000,
        hasScrew: false,
        hasHolePoints: false,
        hasSheetSize: false,
        exportCutWithVbit: false,
        offsetXYValue: false,
        xOffset: 0,
        yOffset: 0,
        setHomeXYValue: false,
        xHome: 0,
        yHome: 0,
        plugin: {},
      },
      prevProperties: {},
      material_assortments: [],
      materials: [],
      cost: {},
      costItems: [],
      totalCost: 0,
      deliveryDate: '要問合せ',
      totalTime: 0,
      costCutting: 0,
      costTax: 0,
      systemFeeRatio: 0.2,
      totalPaintCost: 0,
      toolPathExists: false,
      paintOptions: [
        {id: 0, unitCost: 0, name: '-'},
        {id: 8, unitCost: 5600, name: 'ウレタン塗装・クリア（ツヤあり）'},
        {id: 9, unitCost: 5000, name: 'ウレタン塗装・クリア（半ツヤ）'},
        {id: 10, unitCost: 5000, name: 'ウレタン塗装・クリア（3分ツヤ）'},
        {id: 11, unitCost: 5000, name: 'ウレタン塗装・クリア（ツヤなし）'},
        {id: 12, unitCost: 7500, name: '染色ウレタン塗装（色は別途指定）'},
      ],
      authConfig: {
        signUpConfig: {
          signUpFields: [
            {
              label: 'Username',
              key: 'username',
              required: true,
              displayOrder: 1,
              type: 'email'
            },
            {
              label: 'Password',
              key: 'password',
              required: true,
              displayOrder: 2,
              type: 'password'
            }
          ],
          hiddenDefaults: ['email', 'phone_number']
        },
        confirmSignUpConfig: {},
        forgotPasswordConfig: {}
      },
      isLabAvailable: false,
      isLabMode: this.$emarf.isExperiment,
      useNewApiVersion: false,
      vuildFactoryId: userId,
      costSetting: {},
    };
  },

  computed: {
    pathJson: {
      get () {
        return this.$options.pathJson;
      },
      set (json) {
        this.$options.pathJson = json;

        // set property values from pathJson
        if (json.thickness !== undefined) {
          this.properties.thickness = json.thickness;
        }

        if (json.material) {
          if (json.material.rotation_speed !== undefined) {
            this.properties.rotationSpeed = json.material.rotation_speed;
          }
          if (json.material.xy_speed !== undefined) {
            this.properties.xySpeed = json.material.xy_speed;
          }
          if (json.material.z_speed !== undefined) {
            this.properties.zSpeed = json.material.z_speed;
          }
          if (json.material.path_height != undefined) {
            this.properties.pathHeight = json.material.path_height;
          }
          if (json.material.v_bit_path_height != undefined) {
            this.properties.vBitPathHeight = json.material.v_bit_path_height;
          }
        }

        const tabSize = this.$emarf.getTabSize(this.properties.thickness)
        this.properties.tabWidth = tabSize.width;
        this.properties.tabHeight = tabSize.height;
      }
    }
  },

  watch: {
    'properties.material_id': {
      handler(newVal) {
        this.updateCache();
      },
      deep: true
    },
    'properties.material_assortment_id': {
      handler(newVal) {
        this.updateCache();
      },
      deep: true
    },
    'properties.finish': {
      handler(newVal) {
        this.updateCache();
      },
      deep: true
    },
    'properties.bezel': {
      handler(newVal) {
        this.updateCache();
      },
      deep: true
    },
    'properties.paint_data': {
      handler(newVal) {
        this.updateCache();
      },
      deep: true
    }
  },

  created () {
    Auth.currentAuthenticatedUser().then(user => {
      const groups = user.signInUserSession.accessToken.payload['cognito:groups']
      if (groups.includes('factory')) {
        this.isLabAvailable = true;
      }
    });
  },

  async mounted () {
    const n8nUrl = process.env.N8N_WEBHOOK_URL;
    console.log('[var] URL:', n8nUrl ? `...${n8nUrl.slice(-12)}` : undefined);
    this.debug = (this.$route.query.debug !== undefined && this.$route.query.debug === '1');
    this.baseUrl = (this.$router !== undefined) ? (this.$router.options.base || '/') : './';

    this.isLoading = true;
    try {
      await this.setup();
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    async setupController () {
      const canvas = this.$refs.canvas;
      const options = {
        unit: 0.5,
        divisions: 20,
        boundingBox: false
      };
      this.$options.controller = new PathController(this.baseUrl, canvas, new Theme({}), options);

      await this.$options.controller.setupAsync();
      this.$options.controller.on(Events.UPDATE, () => {
        this.resetSbp();
      });
      this.$options.controller.resize();
      this.cnc = this.$options.controller.getCNCVisibled();
      return this.$options.controller;
    },

    async setup () {
      await this.setupController(FileTypes.PATH);

      window.addEventListener('resize', () => {
        this.$options.controller.resize();
      });

      this.getCostSetting(this.vuildFactoryId).then(costSetting => {
        this.costSetting = costSetting;
      });

      const projectId = this.$route.query[queryProjectIdKey];
      if (projectId !== undefined) {
        // Restore project
        const proj = await this.getProject(projectId);
        this.project = proj;

        // copy project props to this.properties
        const keys = Object.keys(this.properties);

        keys.forEach(key => {
          if (key in proj) {
            this.properties[key] = proj[key];
          }
        });
        const { material_assortment } = proj;
        if (material_assortment !== undefined) {
          const { material_id } = material_assortment;
          if (material_id !== undefined) {
            this.properties.material_id = material_id;
          }
        }

        // プロジェクトが存在する場合はキャッシュを更新
        this.updateCache();

        await this.initializeProject(this.extractPath(proj.pathjson_url));
        this.gtag_event('create_order');  // create_orderの発行タイミングをinitializeProjectが終わったあとに変更

        // create CAM response data from t_project
        const cost = this.createCostMap(this.project.items);

        // Restore material id from material_assortment_id
        const ma = this.material_assortments.find(ma => ma.id === this.properties.material_assortment_id);
        if (ma !== undefined) {
          this.properties.material_id = ma.material_id;
        }

        // Restore properties.finish values from cost items
        this.properties.finish.burr = (cost.cost_burr !== undefined && cost.cost_burr > 0);
        this.properties.finish.sanding = (cost.cost_sanding !== undefined && cost.cost_sanding > 0);
        this.properties.bezel = cost.bezel;

        const paintOption = this.paintOptions.find(option => option.id == Number(cost.paint_id));
        this.properties.paint_data = paintOption || this.paintOptions[0];

        // Retrieve fillet & nesting results from nestingjson_url
        const { fillet, nesting } = await this.getNestingJson(this.project.nestingjson_url);
        console.log('previously recorded nesting data: ', nesting);

        // Restore fillet results before nesting
        this.$refs.Fillet.load(this.pathJson);
        this.$refs.Fillet.deserialize(fillet);

        // Restore nesting results with fillets
        const paths = this.$refs.Fillet.build();
        const bin = this.getBinByMaterialAssortment();
        if (nesting !== undefined) {
          this.$refs.Nesting.load({ ...this.pathJson, paths }, bin, nesting);
        } else {
          this.$refs.Nesting.load({ ...this.pathJson, paths }, bin);
        }
        // this.$refs.Nesting.load({ ...this.pathJson, paths }, bin, nesting.bins.length);
        // this.$refs.Nesting.load({ ...this.pathJson, paths }, bin);
        this.$refs.Nesting.deserialize(nesting);

        await this.handleCAMResponse({
          cost,
          zip: this.project.toolpath_url
        });
        this.last();
      } else {
        // 新規プロジェクトのケース
        const path = this.getJsonPath(this.$route.query.path || '');
        await this.initializeProject(path);
        this.gtag_event('create_order');  // create_orderの発行タイミングをinitializeProjectが終わったあとに変更

        // initialize material_id
        if (this.materials.length > 0) {
          this.properties.material_id = this.materials[0].id;
          const found = this.material_assortments.find(ma => ma.material_id === this.properties.material_id);
          if (found !== undefined) this.properties.material_assortment_id = found.id;
        }
        this.$refs.Fillet.load(this.pathJson);

        // this.next(); // debug
      }
    },

    extractPath (url) {
      if (url.includes('http')) {
        const arr = url.split('/');
        const tail = arr[arr.length - 1];
        const params = tail.split('?');
        return params[0];
      }
      return url;
    },

    extractUuid (s3Key) {
      if (!s3Key) return null;
      const filename = s3Key.split('/').pop();
      return filename.replace(/\.json$/, '');
    },

    async initializeProject (path) {
      this.$options.pathJsonUrl = path;
      try {
        const result = await Storage.get(path, {
          contentType: 'application/json',
        });
        const pathJsonUrl = result.toString();
        const e = await this.fetchData(pathJsonUrl);
        if (!e.aborted) {
          const report = (process.env.NODE_ENV !== 'development');
          this.$options.controller.parse(this.pathJson, report);
          this.$options.controller.focus();
        }
      } catch (e) {
        this.error = true;
        console.warn(e);

        Auth.currentAuthenticatedUser().catch(() => {
          const { fullPath } = this.$router.currentRoute;
          location.href = `/login?redirect=${fullPath}`;
        });

        if (e.message) {
          this.displayAlert(`${e.message}`, e.contact, e.image);
        } else {
          this.displayAlert(`${e}`, false, e.image);
        }
      }
    },

    getJsonPath (path = '') {
      const arr = path.split('.');
      return (arr.length > 1) ? path : `${path}.json`;
    },

    async getCurrentUser () {
      const key = 'getCurrentUser';
      const { data } = await API.graphql(graphqlOperation(queries.getCurrentUser, {}));
      return data[key];
    },

    async fetchMaterials (indices = []) {
      const key = 'listMaterials';
      const { data } = await API.graphql(graphqlOperation(queries.listMaterials, {}));
      return data[key].filter(item => {
        return indices.includes(item.id);
      });
    },

    async fetchMaterialAssortments (condition = { thickness: 24 }) {
      const { data } = await API.graphql(graphqlOperation(queries.listMaterialAssortments, {
        input: {
          is_available: true,
          user_id: this.vuildFactoryId,
          thickness: condition.thickness
        }
      }));

      const materialAssortments = data.listMaterialAssortments || [];

      const groupedItems = materialAssortments.reduce((acc, item) => {
        const key = `${item.material_id}-${item.height}-${item.width}`;

        if (!acc[key] || item.unit_price < acc[key].unit_price) {
          acc[key] = item;
        }
        return acc;
      }, {});

      const materials = Object.values(groupedItems);
      return materials;
    },

    alignPathOrder (path) {
      let { ex_path, in_paths, pocket } = path;
      if (!this.orientation(ex_path)) {
        ex_path.reverse();
      }
      in_paths = in_paths.map((path) => {
        if (!this.orientation(path)) {
          path.reverse();
        }
        return path;
      });
      pocket = pocket.map((po) => {
        let { ex_pocket, in_pocket } = po;
        if (!this.orientation(ex_pocket)) {
          ex_pocket.reverse();
        }
        in_pocket = in_pocket.map((path) => {
          if (!this.orientation(path)) {
            path.reverse();
          }
          return path;
        });
        return {
          ...po, ex_pocket, in_pocket
        };
      });
      return {
        ...path,
        ex_path,
        in_paths,
        pocket
      };
    },

    async fetchPathJson (url) {
      try {
        const { data } = await axios.get(url);
        let { paths } = data;
        paths = paths.map((path) => {
          return this.alignPathOrder(path);
        });
        return {
          ...data, paths
        };
      } catch (e) {
        throw {
          message: `Failed to get path json`,
          contact: true
        };
      }
    },

    async fetchData (pathJsonUrl) {
      const json = await this.fetchPathJson(pathJsonUrl);

      const hasScrew = (json.screws && json.screws.length >= 1);
      const hasSheetSize = (json.bins && json.bins.length >= 1);
      const isCustomSend = json.isCustomSend || false;

      if ((isCustomSend || hasScrew) && hasSheetSize) {
        this.properties.bin.width = json.bins[0].width;
        this.properties.bin.depth = json.bins[0].depth;
      }

      this.properties.hasHolePoints = (json.holePoints && json.holePoints.length >= 1);
      //console.log("Has hole points: ", this.properties.hasHolePoints)

      this.pathJson = hasScrew || isCustomSend ? json : this.alignLongerSideToX(json);
      this.properties.hasScrew = hasScrew;
      this.properties.isCustomSend = isCustomSend;
      this.properties.hasSheetSize = hasSheetSize;
      this.properties.plugin = json.plugin || {};

      const inThickness = json.thickness || 24;
      const { assortments, thickness } = await this.fetchMaterialAssortments({
        thickness: Number(inThickness)
      }).then((assortments) => {
        return Promise.resolve({
          thickness,
          assortments
        });
      });

      this.material_assortments = assortments;
      if (!this.isLabMode && assortments.length <= 0) {
        const message = (
          `<b>` + this.$t('このモデルの板厚({thickness}mm)は現在EMARFで対応していません。', { thickness: thickness }) + `</b>` +
          this.$t('現在対応している板サイズは') +
          `<a href='https://docs.emarf.co/1515709244d280a2b6bdf48d1095c0ba#1525709244d28076a672f4f66db25e6c' target='_blank'>` + this.$t('こちら') + `</a>` +
          this.$t('になります。') + `<br />` + this.$t('希望の板サイズがない場合、個別に相談を承っています')
        );
        throw {
          message,
          contact: true
        };
      }

      if (this.isLabMode) {
        // デフォルトの材料を追加
        this.material_assortments = [
          {
            id: 1,
            material_id: 1,
            unit_price: 0,
          }
        ];
      }

      const materials = await this.fetchMaterials(assortments.map(item => item.material_id));
      this.materials = materials.sort((a, b) => {
        return (Number(a.code) < Number(b.code)) ? -1 : 1; // order by asc
      });

      return materials;
    },

    alignLongerSideToX(pathJson) {
      for (let path of pathJson.paths) {
        let points = path.ex_path;
        let maxX, minX;
        let maxY, minY;
        for (let [index, point] of points.entries()) {
          if (index == 0) {
            maxX = point.x; minX = point.x; maxY = point.y; minY = point.y;
          } else {
            if (point.x > maxX) maxX = point.x;
            if (point.x < minX) minX = point.x;
            if (point.y > maxY) maxY = point.y;
            if (point.y < minY) minY = point.y;
          }
        }

        let x_length = maxX - minX;
        let y_length = maxY - minY;

        const _rotate = (p) => {
          return {
            x: p.x * Math.cos(this.degree2rad(90)) + p.y * Math.sin(this.degree2rad(90)),
            y: -p.x * Math.sin(this.degree2rad(90)) + p.y * Math.cos(this.degree2rad(90))
          }
        }

        if (y_length > x_length) {
          // rotate path 90 degrees
          path.ex_path = points.map(p => _rotate(p));

          if (path.in_paths.length > 0) {
            for (let [index, in_path] of path.in_paths.entries()) {
              path.in_paths[index] = in_path.map(p => _rotate(p));
            }
          }

          if (path.pocket.length > 0) {
            for (let [index, pocket] of path.pocket.entries()) {
              path.pocket[index].ex_pocket = pocket.ex_pocket.map(p => _rotate(p));

              if (pocket.in_pocket.length > 0) { // rotate in_pockets if exist
                for (let [i, inPocket] of pocket.in_pocket.entries()) {
                  path.pocket[index].in_pocket[i] = inPocket.map(p => _rotate(p));
                }
              }
            }
          }

          if (path.single_paths.length > 0) {
            for (let [index, single_path] of path.single_paths.entries()) {
              path.single_paths[index] = single_path.map(p => _rotate(p));
            }
          }
        }
      }
      return pathJson;
    },

    async requestCAM (source, labellingData, sheetLabellingData) {
      if (source === null) {
        throw {
          message: 'Path is null'
        };
      }

      this.resetSbp();
      this.clearCostItems();

      try {
        const { data: response } = await axios.post(`${this.apiRoot}/shopbot`, source, {
          headers: { 'Content-Type': 'application/json' }
        });

        const result = await this.handleCAMResponse(response, labellingData, sheetLabellingData);
        return result;
      } catch (e) {
        if (e.response !== undefined) {
          this.throwCAMErrors(e.response.data);
        }
        if (e.message !== undefined) {
          throw e;
        }
        throw {
          message: `Cutting code generation failed.`,
          contact: true,
          errors: []
        };
      }
    },

    async handleCAMResponse (response, labellingData , sheetLabellingData) {
      this.$options.response = response;
      console.log(response.version, response.cost);
      if (response.message) {
        console.log(response.message);
      }

      // zipを展開してツールパスを描画する
      const zipUrl = response.zip;
      if (zipUrl !== undefined) {
        const files = await this.unzip(zipUrl);

        if (response.cost !== undefined) {
          this.updateCostItems(response.cost, Math.floor(files.length / 2));
        }

        this.sbp = new SBPZip();
        this.sbp.add(zipUrl);
        const green_sbp_color = new THREE.Color(0x00cb92);
        this.$options.controller.addSbp(files, green_sbp_color, labellingData, sheetLabellingData);

        // getting millSize in controller.addSbp() --- BaseController.js
        this.properties.bin.millSize = this.$options.controller.millSize;
        this.properties.bin.width = this.$options.controller.width;
        this.properties.bin.depth = this.$options.controller.depth;

        this.$options.controller.hideSbp();

        const mat = this.materials.find(m => m.id === this.properties.material_id);
        if (mat !== undefined) {
          this.$options.controller.applyTMaterial(mat);
        }

        this.showSbp();
        return {
          files, response, aborted: false
        };
      } else {
        this.throwCAMErrors(response);
      }
    },

    throwCAMErrors (response) {
      const { errors } = response;
      throw {
        message: `CAMに問題が発生しました<br/>エラーを解決の上、再度お試しください`,
        errors: (Array.isArray(errors) ? errors : []).map(err => {
          const content = {
            ...err,
            message: CamErrors[err.ecode]
          };
          return content;
        }),
        contact: true
      };
    },

    createCAMWarnings (warnings_response) {
      return {
        message: `加工は可能ですが、注意が必要な形状が含まれています。`,
        warnings: (Array.isArray(warnings_response) ? warnings_response : []).map(war => {
          const content = {
            ...war,
            message: CamWarnings[war.ecode]
          };
          return content;
        }),
        contact: true
      };
    },

    clearSbp () {
      this.$options.controller.resetSbp();
      this.sbp = null;
    },

    resetSbp () {
      this.clearSbp();
      this.hideSbp();
    },

    showSbp () {
      this.$options.controller.showSbp();
      this.isSbp = true;
    },

    hideSbp () {
      this.$options.controller.hideSbp();
      this.isSbp = false;
    },

    createCostMap (costString) {
      const arr = costString.split(',');
      const regexp = /({|}| )/g;
      const cost = {};
      arr.forEach(row => {
        const cols = row.split('=');
        const key = cols[0].replace(regexp, '');
        const value = cols[1].replace(regexp, '');
        cost[key] = Number(value);
      });
      return cost;
    },

    updateCostItems (cost, numberOfBins = 1) {
      this.clearCostItems();

      const mat = this.materials.find(m => m.id === this.properties.material_id);
      if (mat !== undefined) {
        this.costItems.push(
          new CostItem(
            this.$t('材料費'), `${mat.name} ${this.properties.thickness}mm ${cost.num_sheets_cost}${this.$t('枚')}`,
            cost.cost_sheet, 1, this.$t('式')
          )
        );
      } else {
        this.costItems.push(
          new CostItem(
            this.$t('材料費'), `${this.properties.thickness}mm ${cost.num_sheets_cost}${this.$t('枚')}`,
            cost.cost_sheet, 1, this.$t('式')
          )
        );
      }

      this.costItems.push(
        new CostItem(this.$t('加工費'), `${formatTime(cost.cutting_totaltime)}`, cost.cost_cutting, 1, this.$t('式'))
      );

      const burr = (cost.cost_burr !== undefined && Number(cost.cost_burr) > 0);
      const sanding = (cost.cost_sanding !== undefined && Number(cost.cost_sanding) > 0);
      let finishOptionNote = `-`;
      if (burr && sanding) {
        finishOptionNote = this.$t('バリ取り+表面研磨');
      } else if (burr) {
        finishOptionNote = this.$t('バリ取り');
      }
      if (cost.cost_finish !== undefined) {
        this.costItems.push(new CostItem(this.$t('仕上費'), `${finishOptionNote}`, cost.cost_finish, 1, this.$t('式')));
      }

      if (this.properties.bezel > 0 || this.properties.bezel == true) {
        this.costItems.push(new CostItem(this.$t('面取り加工費'), this.$t('希望する'), this.$t('※別途見積'), 1, this.$t('式')));
      } else {
        this.costItems.push(new CostItem(this.$t('面取り加工費'), `-`, 0, 1, this.$t('式')));
      }

      if (cost.cost_paint !== undefined) {
        this.totalPaintCost = cost.cost_paint;
        // this.costItems.push(
        //   new CostItem(`塗装費`, this.properties.paint_data.name, cost.cost_paint, 1, '式')
        // );
      }

      this.costItems.push(
        new CostItem(this.$t('システム利用料'), this.$t('税抜合計金額のうちの{percent}%', { percent: Math.floor(cost.system_fee_ratio * 100) }), cost.system_fee, 1, this.$t('式')),
      );

      if (cost.discount && cost.discount > 0) {
        this.costItems.push(
          new CostItem(this.$t('キャンペーン割引'), `-${cost.discount_ratio * 100}%`, -cost.discount, 1, this.$t('式'))
        );
      }

      this.costItems.push(
        new CostItem(this.$t('消費税'), `10%`, (cost.total_cost_tax - cost.total_cost), 1, this.$t('式'))
      );

      this.deliveryDate = this.getDeliveryDate(numberOfBins);

      this.cost = cost;
      this.totalCost = cost.total_cost_tax;
      this.totalTime = cost.cutting_totaltime;
      this.costCutting = cost.cost_cutting;
      this.costTax = cost.total_cost_tax - cost.total_cost;
    },

    getDeliveryDate (numberOfBins) {
      // 予想納期のルール
      // https://docs.google.com/presentation/d/1d54PeQCqb0YQl4GqtRbJbLODG9U7S3dNWyw4z6-I8r4/edit#slide=id.g10b87c4b1ea_0_18
      if (numberOfBins <= 6) {
        return '発注確定後10日〜';
      } else if (numberOfBins <= 12) {
        return '10~15日';
      }
      return '要問合せ';
    },

    clearCostItems () {
      this.costItems = [];
    },

    async getCostSetting (userId) {
      const { data } = await API.graphql(graphqlOperation(queries.getCostSetting, { user_id: userId }));
      return data.getCostSetting || {};
    },

    async getProject (id) {
      const { data } = await API.graphql(graphqlOperation(queries.getProject, { id }));
      return data.getProject || {};
    },

    upsertProject (thumbnailUrl) {
      if (this.project.id !== undefined) {
        return this.updateProject(this.project.id, thumbnailUrl);
      } else {
        return this.createProject(thumbnailUrl);
      }
    },

    async createProjectInput (user, thumbnailUrl) {
      const fillet = this.$refs.Fillet.serialize();
      const nesting = this.$refs.Nesting.serialize();

      // 最新のnestingデータを保存
      const { key: nestingjsonUrl } = await Storage.put(
        `nesting-json/${uuidv4()}.json`,
        { fillet, nesting }
      );

      // nesting中にpartsがコピーされた場合、pathJsonデータを更新
      const nesting_parts = this.$refs.Nesting.getParts();
      if (nesting_parts.length > 0) {
        this.pathJson.paths = [];
        for (let i = 0; i < nesting_parts.length; i++) {
          let part = nesting_parts[i];
          part.source.nesting_id = nesting.parts[i].id; // set nesting_id for identify
          this.pathJson.paths.push(part.source);
        }
      }

      // 最新のPathJsonデータを保存
      const pathJSON = this.addFabricationToPathJSON(this.pathJson);
      const { key: pathJsonUrl } = await Storage.put(`${uuidv4()}.json`, pathJSON);

      // CAMのレスポンスデータ
      const response = this.$options.response;

      return {
        user_id: user.id,
        name: this.properties.name,
        quantity: this.properties.quantity,
        material_assortment_id: this.properties.material_assortment_id,
        items: {
          ...response.cost,
          paint: this.properties.paint_data.name,
          paint_id: this.properties.paint_data.id,
          paintCost: this.totalPaintCost,
          bezel: this.properties.bezel,
          bezelCost: this.properties.bezel == 0 ? 0 : this.properties.bezel == false ? 0 : 1,
          millSize: this.properties.bin.millSize
        },
        cost: response.cost.total_cost,
        pathjson_url: pathJsonUrl,
        nestingjson_url: nestingjsonUrl,
        toolpath_url: response.zip,
        thumbnail_url: thumbnailUrl
      };
    },

    addFabricationToPathJSON(pathJSON) {
      // CAMのレスポンスデータ
      const response = this.$options.response;

      let material = this.materials.find(m => m.id === this.properties.material_id);
      if (!material || this.isLabMode) {
        material = { name: '未選択' };
      }

      return {
        ...pathJSON,
        fabrication: {
          settings: {
            machine: "ShopBot",
            path_height: this.properties.pathHeight,
            speed: {
              xy: this.properties.xySpeed,
              z: this.properties.zSpeed,
              jog: this.properties.jogSpeed,
              rotation: this.properties.rotationSpeed,
            },
            mill: {
              size: this.properties.millSize,
            },
            material: {
              name: material.name,
            },
          },
          cost: {
            items: [
              { name: '材料費', value: response.cost.cost_sheet },
              { name: '加工費', value: response.cost.cost_cutting },
              { name: '仕上費', value: response.cost.cost_finish },
              { name: '消費税', value: response.cost.total_cost_tax - response.cost.total_cost }
            ],
            total: response.cost.total_cost_tax
          },
          time_second: response.cost.cutting_totaltime,
          cutfile: response.zip
        }
      }
    },

    async createProject (thumbnailUrl) {
      const key = 'createProject';

      const user = await this.getCurrentUser();
      const input = await this.createProjectInput(user, thumbnailUrl);
      const params = {
        createProjectInput: input
      };
      const result = await API.graphql(graphqlOperation(mutations.createProject, params));
      return result.data[key];
    },

    async updateProject (id, thumbnailUrl) {
      const key = 'updateProject';

      const user = await this.getCurrentUser();
      const input = await this.createProjectInput(user, thumbnailUrl);
      input.id = id;
      const params = {
        updateProjectInput: {
          ...input, id, is_deleted: false // merge
        }
      };
      const result = await API.graphql(graphqlOperation(mutations.updateProject, params));
      return result.data[key];
    },

    generateToolPath (pathJson = undefined) {
      // TODO: 長すぎるのでリファクタリング

      // Use local pathJson
      if (pathJson === undefined) {
        pathJson = _.cloneDeep(this.pathJson);
      }

      // @MEMO
      // Sort paths so that the total path for knife is reduced
      let xAxisSorted = [];
      for (let i = 0; i < pathJson.paths.length; i++) {
        const path = pathJson.paths[i];
        const xs = path.ex_path.map( p => p.x );
        const minX = Math.round( Math.min(...xs) );

        const found = xAxisSorted.find(item => item.minX > minX - 250 && item.minX < minX + 250);
        if (found !== undefined) {
          found.paths.push(path);
        } else {
          xAxisSorted.push({
            'minX': minX,
            'paths': [path]
          });
        }
      }

      xAxisSorted.sort((a, b) => {
        if (a.minX < b.minX) return -1;
        if (a.minX > b.minX) return 1;
        return 0;
      });

      xAxisSorted.forEach((item, i) => {
        if (i % 2 === 0) {  // even
          // sort y ascend
          item.paths.sort( (a,b) => {
            const ays = a.ex_path.map( p => p.y );
            const bys = b.ex_path.map( p => p.y );
            const a_minY = Math.round( Math.min(...ays) );
            const b_minY = Math.round( Math.min(...bys) );
            if(a_minY > b_minY) return 1;
            if(a_minY < b_minY) return -1;
            return 0;
          } );
        } else {  // odd
          // sort y descend
          item.paths.sort( (a,b) => {
            const ays = a.ex_path.map( p => p.y );
            const bys = b.ex_path.map( p => p.y );
            const a_maxY = Math.round( Math.max(...ays) );
            const b_maxY = Math.round( Math.max(...bys) );
            if(a_maxY > b_maxY) return -1;
            if(a_maxY < b_maxY) return 1;
            return 0;
          } );
        }
      });

      let sortedPaths = [];
      for(let eachSortedPath of xAxisSorted){
        sortedPaths = sortedPaths.concat(eachSortedPath.paths);
      }

      pathJson.paths = sortedPaths;

      // @MEMO
      // Display alert when any board is blank
      if(this.step == 1){ // for manual nesting
        const testPoints = this.$refs.Nesting.$options.nesting.parts.map( part => {
          return part.element.children[0].points[0];
        } );
        let blankBin = true;
        for(let bin of this.$refs.Nesting.$options.nesting.bins){
          blankBin = true; // set true to check a new bin
          let minX = bin.position.x;
          let maxX = bin.position.x + bin.width;
          let minY = bin.position.y;
          let maxY = bin.position.y + bin.depth;
          for(let point of testPoints){
            if(point.x > minX && point.x < maxX && point.y > minY && point.y < maxY){
              blankBin = false;
              break;
            }
          }
          if(blankBin){ // if any board is blank, break and display alert
            break;
          }
        }
        if (blankBin) {
          this.toStep1(); // code below seems to move 1 step forward, so the final step would be 2
          const message = this.$t('部材が配置されていない板があります。');
          this.displayAlert(message);
          return Promise.reject(message);
        }
      }

      if (this.isLabMode) { // Labモードのとき
        pathJson.mill = this.properties.millSize;
        pathJson.material = {
          ...pathJson.material,
          is_expert: this.properties.isExpert,
          price: 0,
          rotation_speed: this.properties.rotationSpeed,
          xy_speed: this.properties.xySpeed,
          z_speed: this.properties.zSpeed,
          jog_speed: this.properties.jogSpeed,
          path_height: this.properties.pathHeight,
          v_bit_path_height: this.properties.vBitPathHeight,
          pocket_step: this.properties.pocketStep,
          pocket_path_height: this.properties.pocketPathHeight,
          first_cut_is_cw: this.properties.isFirstCutCW,
          first_cut_offset: this.properties.firstCutOffset,
          first_cut_in_path_offset: this.properties.firstCutInPathOffset,
          first_cut_offset_value: this.properties.firstCutOffsetValue,
          first_cut_path_height_list: this.properties.firstCutPathHeightList,
          second_cut_path_height_list: this.properties.secondCutPathHeightList,
          add_second_cut: this.properties.addSecondCut,
          second_cut_is_cw: this.properties.isSecondCutCW,
          second_cut_path_height: this.properties.secondPathHeight,
          change_second_cut_speed: this.properties.changeSecondCutSpeed,
          second_cut_xy_speed: this.properties.secondCutXYSpeed,
          second_cut_z_speed: this.properties.secondCutZSpeed,
          is_triangular_tab: this.properties.isTriangularTab,
          is_trimmer_hole: this.properties.isTrimmerHole,
          trimmer_hole_offset: this.properties.trimmerHoleOffset,
          export_cut_with_vbit: this.properties.exportCutWithVbit,
          hole_diameter: this.properties.holeDiameter,
          hole_path_height: this.properties.holePathHeight,
          hole_rotation: this.properties.holeRotation,
          tab: {
            width: this.properties.tabWidth,
            height: this.properties.tabHeight
          },
          xyOffset: {
            offset_xy: this.properties.offsetXYValue,
            x_offset: this.properties.xOffset,
            y_offset: this.properties.yOffset, 
          },
          xyHome: {
            set_xy_home: this.properties.setHomeXYValue,
            x_home: this.properties.xHome,
            y_home: this.properties.yHome,
          }
        };
        pathJson.bins = [
          {
            width: this.properties.bin.width,
            depth: this.properties.bin.depth
          }
        ];
      } else { // 通常モードのとき
        const found = this.material_assortments.find(ma => (
          ma.id === this.properties.material_assortment_id
        ));
        if (found) {
          pathJson.material = {
            ...pathJson.material,
            ...found,
            price: found.unit_price
          };
          pathJson.bins = [
            {
              width: found.width,
              depth: found.height | found.depth
            }
          ];
        } else {
          const message = `指定された材質が無効です`;
          this.displayAlert(message);
          return Promise.reject(message);
        }
      }

      pathJson.finish = this.properties.finish;
      pathJson.bezel = this.properties.bezel;
      pathJson.paint = { unit_cost: this.properties.paint_data.unitCost };
      pathJson.nesting = false;
      pathJson.cut_sheet = false;
      pathJson.cost = {
        cutting_cost_per_hour: this.costSetting.cutting_cost,
      }

      console.log('PathJSON:', pathJson);

      let labellingData = this.getLabels(sortedPaths)
      let sheetLabellingData = pathJson.sheetLabels || [];

      if (this.debug) {
        const jsonStr = JSON.stringify(pathJson);
        const url = 'data:text/json;charset=utf-8,' + encodeURIComponent(jsonStr);
        this.download(url, `path.json`);
      }

      this.isLoading = this.isRequestingCAM = true;

      pathJson.source_pathjson_id = this.extractUuid(this.$options.pathJsonUrl);

      return this.requestCAM(pathJson, labellingData, sheetLabellingData)
        .then((e) => {
          if (this.debug) {
            this.sbp.download();
          }
          const { files } = e;
          if(e.response.warnings.length != 0){
            let warningObj = this.createCAMWarnings(e.response.warnings);
            this.displayAlert(warningObj.message, warningObj.contact, warningObj.warnings);
          }
          this.updateCostItems(e.response.cost, Math.floor(files.length / 2));

          if( this.step == 2 ){
            // NotionID184 加工プレビュー画面が表示されてcostが解決された時がここ？
            this.gtag_event('set_order')
          }

          return Promise.resolve();
        }).catch((e) => {
          console.error(e);
          if (e.message !== undefined) {
            this.displayAlert(e.message, e.contact, e.errors);
          } else {
            this.displayAlert(e, false, e.errors);
          }
        }).finally(() => {
          this.isLoading = this.isRequestingCAM = false;
        });
    },

    getLabels(sortedPaths) {
      let paths = sortedPaths
      let labellingData = [];
      for(let path of paths){
        labellingData.push({
          name: path.name,
          label: path.label,
          position: this.getApproximateCenter(path.ex_path),
        })
      }
      return labellingData
    },

    getApproximateCenter(ex_path) {
      let maxX = Number.MIN_SAFE_INTEGER;
      let minX = Number.MAX_SAFE_INTEGER;
      let minY = Number.MAX_SAFE_INTEGER;
      let maxY = Number.MIN_SAFE_INTEGER;
      ex_path.forEach((p) => {
        maxX = Math.max(maxX, p.x)
        minX = Math.min(minX, p.x)
        maxY = Math.max(maxY, p.y)
        minY = Math.min(minY, p.y)
      })
      return {
        x: minX + (maxX - minX) / 2,
        y: minY + (maxY - minY) / 2,
        z: 0,
      }
    },

    async showQuotation () {
      if (this.project.id !== undefined) {
        this.$refs.QuotationPopup.show();
      } else {
        // if preview for unsaved project,
        // save project to get project id & show quotation
        this.isLoading = true;
        try {
          const thumbnailUrl = await this.storeThumbnail();
          const project = await this.createProject(thumbnailUrl);
          this.project = project;
          this.insertQuery(queryProjectIdKey, this.project.id);
          this.$refs.QuotationPopup.show();
        } finally {
          this.isLoading = false;
        }
      }
    },

    insertQuery (key, value) {
      key = encodeURI(key);
      value = encodeURI(value);

      let kvp = document.location.search.substr(1).split('&');
      let i = kvp.length;
      while (i--) {
        let x = kvp[i].split('=');
        if (x[0] === key) {
          x[1] = value;
          kvp[i] = x.join('=');
          break;
        }
      }

      if (i < 0) {
        kvp[kvp.length] = [key, value].join('=');
      }
      window.history.pushState('', '', `?${kvp.join('&')}`);
    },

    async saveProject () {
      if (this.isLoading) return;
      this.isLoading = true;
      const thumbnailUrl = await this.storeThumbnail();
      const proj = await this.upsertProject(thumbnailUrl);
      return proj;
    },

    async onOrder () {


      const proj = await this.saveProject();
      if (proj === undefined) return;
      window.location.href = `${window.location.protocol}//${window.location.host}/order/${proj.id}`;
    },

    async onSaveMypage () {
      this.$gtag.event('savemypage_click');
      if (this.isProjectAfterRelease20241208()) {
        const proj = await this.saveProject();
        if (proj === undefined) return;
        this.toMypage();
      }
    },

    toMypage () {
      window.location.href = `${window.location.protocol}//${window.location.host}/mypage/works`;
    },

    async storeThumbnail () {
      const base64 = this.$options.controller.captureBase64();
      const storeThumbnailInput = {
        file_data: base64,
        extension: 'jpg'
      };
      const { data } = await API.graphql(graphqlOperation(mutations.storeThumbnail, { storeThumbnailInput }));
      return data.storeThumbnail.url;
    },

    prev () {
      switch (this.step) {
        case 2: {
          this.$options.controller.stopRendering();
          break;
        }
      }
      this.step = Math.max(0, this.step - 1);
      this.$refs.StepMenuRoot.scrollTop = 0;
    },

    nonesting () {
      // NotionID184 加工条件設定ページで 配置なしで加工へ を押した時
//      this.gtag_event('create_order');  // Step1ロード時に発生 に変更

      const paths = this.$refs.Fillet.build();
      const pathJSON = { ...this.pathJson, paths };
      this.generateToolPath(pathJSON);

      this.step = 2;
      this.$refs.StepMenuRoot.scrollTop = 0;
      this.$options.controller.startRendering();

      this.$nextTick(() => {
        this.$options.controller.resize();
      });
    },

    // NotionID184 イベントを生成して送信
    gtag_event(eventname)
    {
      var x = _.cloneDeep(this.pathJson);
      delete x.paths; // イベントパラメーターにpathsは除去
      var eopt  = {
        'platform': this.pathJson && this.pathJson['plugin'] && this.pathJson['plugin']['platform'] ? this.pathJson['plugin']['platform'] : 'unknown',
        'pathjson': JSON.stringify(x),
      }

      if( eventname != 'create_order' ){  // create_order の時は以下のパラメーターは付与しない
        eopt['option_material']  = this.properties.material_id;
        var fin = [];
        if( this.properties.finish ) fin.push('burr');
        if( this.properties.sanding ) fin.push('sanding');
        eopt['option_shiage'] = fin.join(',');
        eopt['option_men']  =  this.properties.bezel;
        eopt['price'] = this.totalCost;
      }
      console.log("event creation / "+eventname,eopt);
      this.$gtag.event(eventname,eopt);
      cwLogger(this.$emarf.cwConfig,eventname+" on gh_webgl_interpreter");
    },

    next_step1 () {

      this.next();
    },

    next_step2 () {
      // NotionID184 配置設定から加工プレビューへ遷移
      this.next();
    },

    next () {
      switch (this.step) {
        case 0: {
          this.setupNesting();
          break;
        }
        case 1: {
          // manual nesting
          if (this.$refs.Nesting.validate()) {
            const json = this.$refs.Nesting.build();
            this.generateToolPath(json);
          } else {
            this.displayAlert(`配置に問題のある部材があります。`, false);
            return;
          }
          this.$options.controller.startRendering();
          break;
        }
      }
      this.step++;
      this.$refs.StepMenuRoot.scrollTop = 0;

      this.$nextTick(() => {
        this.$options.controller.resize();
      });
    },

    async toStep1 () {
      this.$options.controller.stopRendering();
      this.step = 0;
      this.$refs.StepMenuRoot.scrollTop = 0;
      this.toolPathExists = true;
    },

    async skip () {
      // NotionID184 加工条件設定ページで 配置設定をスキップ を押した時
//      this.gtag_event('create_order');  // Step1ロード時に発生 に変更

      // Stepを飛ばして最後の加工データ生成までスキップする場合の処理
      try {
        await this.setupNesting();
        const result = await this.nestByApi();
        if (!result) {
          return;
        }
        const pathJSON = this.$refs.Nesting.build();
        if (this.emptyPartsExist(pathJSON)) {
          throw Error('自動配置結果に問題のある部材があります。<br>手動配置画面で部材位置の調整をお試しください。');
        }
        await this.generateToolPath(pathJSON);
        this.last();
      } catch (e) {
        if (e.message) {
          this.displayAlert(`${e.message}`, e.contact, e.image);
        } else {
          this.displayAlert(`${e}`, false, e.image);
        }
      }
    },

    emptyPartsExist(pathJSON) {
      const { paths } = pathJSON;
      if (paths && Array.isArray(paths)) {
        for (let i = 0; i < paths.length; i++) {
          const part = paths[i];
          if (Object.keys(part).length === 0) {
            return true;
          }
        }
      }
      return false;
    },

    cancel () {
      this.step = 2;
      this.$options.controller.startRendering();
    },

    last () {
      // Stepを飛ばして最後の加工データプレビューを表示する処理
      this.step = 2;
      this.$options.controller.startRendering();
      this.$nextTick(() => {
        this.$options.controller.resize();
      });
    },

    filletAll () {
      this.$refs.Fillet.all();
    },

    filletUndo () {
      this.$refs.Fillet.undo();
    },

    filletRedo () {
      this.$refs.Fillet.redo();
    },

    filletReset () {
      this.$refs.Fillet.reset();
    },

    selectFilletType (filletType) {
      this.$refs.Fillet.select(filletType);
    },

    getBinByMaterialAssortment () {
      let bin = this.properties.bin;

      if (this.isLabMode) {
        return bin
      }

      const found = this.material_assortments.find(ma => (
        ma.id === this.properties.material_assortment_id
      ));
      if (found !== undefined) {
        bin = {
          width: found.width,
          height: found.height
        };
      }

      return bin;
    },

    setupNesting () {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          // Integrate fillet results
          const paths = this.$refs.Fillet.build();
          const bin = this.getBinByMaterialAssortment();
          this.$refs.Nesting.load({ ...this.pathJson, paths }, bin);
        });
        resolve();
      });
    },

    orientation (vertices) {
      const count = vertices.length;
      if (count < 3) return undefined;
      let area = 0;
      for (var i = 0, j = count - 1; i < count; ++i) {
        area += (vertices[j].x + vertices[i].x) * (vertices[j].y - vertices[i].y);
        j = i;
      }
      return -area * 0.5 >= 0;
    },

    simplify (vertices, delta = 1e-1, offset = 20, miterLimit = 2.5, curveTolerance = 1.0) {
      const scale = 1e6;

      let path = ClipperLib.Clipper.CleanPolygon(vertices.map(v => {
        return {
          X: v.x * scale,
          Y: v.y * scale
        };
      }), delta * scale);

      /*
      const orientation = ClipperLib.Clipper.Orientation(path);
      if (!orientation) {
        path = path.reverse();
      }
      */

      const clipper = new ClipperLib.ClipperOffset(miterLimit, curveTolerance * scale);
      clipper.AddPath(path, ClipperLib.JoinType.jtSquare, ClipperLib.EndType.etClosedPolygon);
      const paths = new ClipperLib.Paths();
      clipper.Execute(paths, offset * scale);

      const inv = 1 / scale;
      const simplified = paths[0].map(v => {
        return {
          x: v.X * inv,
          y: v.Y * inv
        };
      });

      if (simplified.length <= 0) {
        return vertices;
      }
      return simplified;
    },

    degree2rad (deg) {
      return deg * (Math.PI / 180);
    },

    async nest () {
      // execute nesting by nesting api
      const { bins, paths, thickness } = this.pathJson;
      const clearance = this.$emarf.getClearanceFromThickness(thickness);
      const simplifyThreshold = 1e-2 * 5;

      const found = this.material_assortments.find(ma => (
        ma.id === this.properties.material_assortment_id
      ));
      const nBins = bins.map((b, id) => {
        let w = found !== undefined ? found.width : b.width;
        let h = found !== undefined ? found.height : (b.height !== undefined ? b.height : b.depth);

        if (this.isLabMode) {
          w = this.properties.bin.width;
          h = this.properties.bin.depth;
        }

        return {
          id,
          width: w - (clearance.bin * 2),
          height: h - (clearance.bin * 2)
        };
      });

      const offset = clearance.part; // Clearance.partDelta から変更
      const parts = paths.map((path, id) => {
        // パスの単純化
        let delta = simplifyThreshold;
        let points = this.simplify(path.ex_path, delta, offset);
        let count = 1;
        while (points.length > 100 && count < 5) {
          delta = simplifyThreshold * 2 * count;
          points = this.simplify(path.ex_path, delta, offset);
          count += 1;
        }
        return {
          id,
          points: points.map(p => ({
            x: p.x,
            y: p.y
          }))
        };
      });

      const input = {
        bins: nBins,
        parts,
        config: {
          generations: 8,
          population: 8,
          rotationSteps: 1,
          spacing: 0
        }
      };

      this.$options.axiosCancelTokenSource = axios.CancelToken.source();
      this.isLoading = this.isRequestingNesting = true;

      const handleError = (e) => {
        let message = (
          "部材自動配置の計算中にエラーが発生しました。<br>" +
          "計算可能な部材数を超えている、あるいは、部材がお選びいただいた板サイズに入らない可能性があります。<br>" +
          "手動配置をお試しください。"
        );
        if (e.response && e.response.data) {
          message = NestingErrors[e.response.data.code];
        }
        this.displayAlert(message);
        console.warn(e);
      };

      let result;
      try {
        const config = {
          headers: { 'Content-Type': 'application/json' },
          cancelToken: this.$options.axiosCancelTokenSource.token
        };
        const { data: { path } } = await axios.post(
          nestingApiRoot, input, config
        ).catch(error => {
          handleError(error);
        });
        if (path !== undefined) {
          const { data } = await axios.get(this.getStorageUrl('nesting', path));
          result = data;
        }
      } catch (error) {
        handleError(error);
      } finally {
        this.isLoading = this.isRequestingNesting = false;
      }

      return result;
    },

    async nestByApi () {
      try {
        const result = await this.nest();
        if (result !== undefined) {
          this.$refs.Nesting.nestByApi(result);
          return true;
        }
        return false;
      } catch (e) {
        return false;
      }
    },

    partAdd () {
      this.$refs.Nesting.addPart();
    },

    partRemove () {
      this.$refs.Nesting.removePart();
    },

    nestingAdd () {
      this.$refs.Nesting.add();
    },

    nestingRemove () {
      this.$refs.Nesting.remove();
    },

    nestingRedo () {
      this.$refs.Nesting.redo();
    },

    nestingUndo () {
      this.$refs.Nesting.undo();
    },

    nestingReset () {
      this.$refs.Nesting.reset();
    },

    async getNestingJson (url) {
      if (url && url.length > 0) {
        // restore manual nesting result from s3
        const nestingjsonUrl = await Storage.get(url, {
          contentType: 'application/json',
        });
        const { data } = await axios.get(nestingjsonUrl);
        return data;
      }
      return {
        fillet: {},
        nesting: {}
      };
    },

    onCancel () {
      this.$options.axiosCancelTokenSource.cancel();
    },

    async downloadSBP () {
      let is_expert = this.properties.isExpert;
      let source_pathjson_id = this.$options.pathJsonUrl


      if (this.sbp !== null) {
        this.sbp.name = `emarf-sbp-${this.properties.name}`;
        this.sbp.download();

        if (is_expert) {
          // Send to slack using n8n
          const webhookUrl = process.env.N8N_WEBHOOK_URL || '';
          if (webhookUrl) {
            Auth.currentAuthenticatedUser().then(user => {
              const email = user.attributes.email || '';
              return axios.post(webhookUrl, {
                source_pathjson_id: this.extractUuid(source_pathjson_id),
                email,
                sbp_url: this.sbp.urls[0] || '',
              });
            }).catch(e => {
              console.warn('Failed to send to n8n webhook:', e);
            });
          } else {
            console.warn('N8N_WEBHOOK_URL is not configured');
          }
        }
        else{
          console.warn("User not needed to provide feedback")
        }
      } else {
        alert('SBPダウンロード処理に失敗しました');
      }
    },

    

    toNextSbpPreview() {
      if(this.sbp.urls.length == 0) {
        alert('SBPダウンロード処理に失敗しました');
        return;
      }
      const url = this.sbp.urls[0];
      const zipName = url.split('/').pop().split('.')[0];
      // jump to next page
      window.open(`/sandbox/?sbp=${zipName}`, '_blank');
    },

    toggleLabMode() {
      this.isLabMode = !this.isLabMode;
      if (this.isLabMode) {
        const q = { ...this.$route.query, lab: 1 };
        this.$router.push({ query: q });
      } else {
        const q = { ...this.$route.query };
        delete q.lab;
        this.$router.push({ query: q });
      }
    },

    changeApiVersion(useNewVersion) {
      this.useNewApiVersion = useNewVersion;
      if (useNewVersion) {
        console.log("use new version");
        //this.apiRoot = 'http://127.0.0.1:8080';
        this.apiRoot = 'https://library-api.emarf.co/cam_rust';
      } else {
        console.log("use old version");
        this.apiRoot = (process.env.API_ENV === 'development')
          ? 'https://dev-cam.emarf.co'
          : (process.env.API_ENV === 'lab')
            ? 'https://cam-lab.emarf.co'
            : 'https://cam.emarf.co';
      }
    },

    changeMachine(machineId) {
      const found = this.$emarf.machines.find(machine => (machine.id === machineId));
      if (found !== undefined) {
        this.properties.bin.width = found.bedWidth;
        this.properties.bin.depth = found.bedDepth;
        this.properties.rotationSpeed = found.rotationSpeed;
        this.properties.xySpeed = found.xySpeed;
        this.properties.zSpeed = found.zSpeed;
        this.properties.jogSpeed = found.jogSpeed;
      }
    },

    changeMillSize(millSize) {
      this.$refs.Fillet.updateMill(millSize);
    },

    isProjectAfterRelease20241208() {
      if (this.project) {
        const updatedAt = new Date(this.project.updated_at + "Z");
        const releaseDate = new Date("2024-12-06 05:00:00Z");
        if (updatedAt < releaseDate && this.project.toolpath_url === this.$options.response.zip) {
          this.displayAlert("この加工データは古いバージョンのデータです。条件設定もしくは配置設定に戻り、再度加工データを作成してください。");
          return false;
        }
      }
      return true;
    },

    // キャッシュを更新するメソッド
    updateCache() {
      console.log('cache updated');
      const { material_id, material_assortment_id, thickness, finish, bezel, paint_data } = this.properties;
      Cache.set('material_id', material_id);
      Cache.set('material_assortment_id', material_assortment_id);
      Cache.set('thickness', thickness);
      Cache.set('finish', finish);
      Cache.set('bezel', bezel);
      Cache.set('paint_data', paint_data);
    },

    // キャッシュをクリアするメソッド
    clearCache() {
      Cache.clear();
    },
  }
};

</script>



// WEBPACK FOOTER //
// src/pages/PluginBase.vue